import lodashCloneDeep from "lodash/cloneDeep";
import lodashGet from "lodash/get";

import { httpGet } from "@/services/api.service";
import { ENDPOINT_GRD_PROFILE } from "@/common/constants/api";

export { _getGRDProfile as getGRDProfile };

let grdProfile = null;

const _getGRDProfileConfig = async () => {
  try {
    const url = `${ENDPOINT_GRD_PROFILE}/content`;
    const result = await httpGet({ url });
    const { data } = JSON.parse(result);

    if (lodashGet(data, "grdProfile")) {
      return data.grdProfile;
    }

    return false;
  } catch (error) {
    Promise.reject(
      "Issue getting GRD profile config in grd.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getGRDProfile = async (force) => {
  if (!grdProfile || force) {
    try {
      const profileData = await _getGRDProfileConfig();
      if (profileData && profileData.length > 0) {
        grdProfile = profileData;
      } else {
        throw "Error getting GRD profile data.";
      }
      return profileData;
    } catch (error) {
      console.error("GRD API: " + error);
      return false;
    }
  }
  return lodashCloneDeep(grdProfile);
};
